<template>
    <div class="container">
        <h1>tags</h1>
        <textarea v-model="text" rows=4></textarea>
        <br>
        <button @click="close">Close</button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            text: ''
        };
    },

    props: { tags: Array },

    created: function() {
        this.text = this.tags.join(',');
    },

    methods: {
        close() {
            this.$emit('langsel', this.text.split(','));
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.container {
    margin: 20px;
}

textarea {
    font-size: 16px;
    /* width: 100%; */
}
</style>
